class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.onOutsideInteraction = (event) => {
      if (!this.contains(event.target)) this.close();
    };
    this.hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.addEventListener('pointerenter', () => {
      clearTimeout(this.hoverTimeout);
      if (!this.hoverQuery.matches) return;
      this.hoverTimeout = setTimeout(() => {
        this.header.querySelectorAll('header-menu').forEach((menu) => {
          if (menu !== this) menu.close();
        });
        this.mainDetailsToggle.open = true;
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
      }, 100);
    });
    this.addEventListener('pointerleave', () => {
      clearTimeout(this.hoverTimeout);
      if (!this.hoverQuery.matches) return;
      this.hoverTimeout = setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      }, 180);
    });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        clearTimeout(this.hoverTimeout);
        this.close();
        this.mainDetailsToggle.querySelector('summary').focus();
      }
    });
  }

  connectedCallback() {
    document.addEventListener('focusin', this.onOutsideInteraction);
    document.addEventListener('pointerdown', this.onOutsideInteraction);
  }

  close() {
    clearTimeout(this.hoverTimeout);
    super.close();
  }

  disconnectedCallback() {
    clearTimeout(this.hoverTimeout);
    document.removeEventListener('focusin', this.onOutsideInteraction);
    document.removeEventListener('pointerdown', this.onOutsideInteraction);
  }

  onToggle() {
    if (!this.header) return;
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', String(this.mainDetailsToggle.open));
    this.header.preventHide = Boolean(this.header.querySelector('header-menu details[open]'));

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
